 import vid1 from '../assets/vid/blog-app demo.mp4'
 import vid2 from '../assets/vid/techybuy-demo.mp4'
 import vid3 from '../assets/vid/portfolio-demo.mp4'
 import img1 from '../assets/img/blog-app.png'
 import img2 from '../assets/img/techybuy.png'
 import img3 from '../assets/img/portfolio.png'

export const ProjectData = [
    {
        "id" : 1,
        "name" : "Blog-App",
        "technology" : "ReactJs | NodeJs | MySQL | Express",
        "imageUrl" : img1,
        "vidUrl" : vid1,
        "WebUrl" : "",
        "desc": "This website is a responsive e-commerce website using Next.js and CSS, with a Sanity backend for content management and Stripe API for secure payments. Implement user-friendly React.js features for an enhanced user experience."
    },
    {
        "id" : 2,
        "name" : "TechyBuy.lk",
        "technology" : "NextJs | Sanity | Stripe",
        "imageUrl" : img2,
        "vidUrl" : vid2,
        "WebUrl" : "https://mayura111.github.io/techybuy/",
        "desc" : "This website is a responsive e-commerce website using Next.js and CSS, with a Sanity backend for content management and Stripe API for secure payments. Implement user-friendly React.js features for an enhanced user experience."
    },
    {
        "id" : 3,
        "name": "Portfolio",
        "technology" : "ReactJs",
        "imageUrl" : img3,
        "vidUrl" : vid3,
        "WebUrl" : "https://mayura111.github.io/portfolio/",
        "desc" : "This website is a responsive e-commerce website using Next.js and CSS, with a Sanity backend for content management and Stripe API for secure payments. Implement user-friendly React.js features for an enhanced user experience."
    },
]
